import { BASE_URL } from '../../../../../utils/config.base-url'

export const DOCUMENT_INCOMING_PREFIX_URL = '/document-incoming'
export const URL_ENDPOINT_DOCUMENT_INCOMING = `${BASE_URL}/document-incoming`
export const URL_ENDPOINT_DOCUMENT_INCOMING_APPROVAL_LOG = `${BASE_URL}/document-incoming-approval-log/list/by-document-incoming`
